import {
	Button,
	HStack,
	Input,
	Text,
	VStack,
} from '@montel/montelpro-shared-components-v2';
import { DEVELOPER_API_ROUTE, SUBSCRIPTIONS_API_ROUTE } from 'apiRoutes';
import useSubmit, { POST } from 'hooks/useSubmit';
import { FunctionComponent, useState } from 'react';
import { RequestStatus } from 'types/RequestStatus';

const GetCachedPermissionsTool: FunctionComponent = () => {
	const [subscriberId, setSubscriberId] = useState<string>('');

	const [bustCachedPermissions, status] = useSubmit(
		`${DEVELOPER_API_ROUTE}/BustCachedPermissions`,
		POST,
		{
			messageOnError: 'An error occurred while fetching permissions.',
			messageOnSuccess: 'Permissions fetched successfully.',
			showApiError: true,
		},
	);

	const onBustCachedPermissions = () => {
		bustCachedPermissions({ subscriberId });
	};

	return (
		<VStack>
			<Text>Bust users&#39; cached permissions</Text>
			<HStack wrap="nowrap">
				<Input
					label="Subscriber ID"
					type="text"
					autoComplete="off"
					name="subscriberId"
					value={subscriberId}
					required
					onChange={(event) => setSubscriberId(event.target.value)}
				/>
			</HStack>
			<Button
				onClick={onBustCachedPermissions}
				type="submit"
				text="Bust cached permissions"
				loadingText="Busting permissions ..."
				isLoading={status === RequestStatus.LOADING}
				isDisabled={!subscriberId.trim().length}
			/>
		</VStack>
	);
};

export default GetCachedPermissionsTool;
